import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../../utils/errors';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { IOnboardingQuestionnaireAgreement } from '../../../../../pages/questionnaires/onboarding/components/forms/agreement/types';
import type { OnboardingQuestionnaireState } from '../../types';
import type { OnboardingAgreementThunks } from './types';

export function addOnboardingAgreementCases(
  builder: ActionReducerMapBuilder<OnboardingQuestionnaireState>,
  thunks: OnboardingAgreementThunks,
) {
  addUpdateOnboardingQuestionnaireAgreementCases(builder, thunks);
}

function addUpdateOnboardingQuestionnaireAgreementCases(
  builder: ActionReducerMapBuilder<OnboardingQuestionnaireState>,
  thunks: OnboardingAgreementThunks,
) {
  const { updateOnboardingQuestionnaireAgreement } = thunks;
  builder
    .addCase(
      updateOnboardingQuestionnaireAgreement.pending,
      (state: OnboardingQuestionnaireState) => {
        state.updateAgreementLoading = true;
        state.error = null;
      },
    )
    .addCase(
      updateOnboardingQuestionnaireAgreement.fulfilled,
      (
        state: OnboardingQuestionnaireState,
        action: PayloadAction<IOnboardingQuestionnaireAgreement>,
      ) => {
        state.updateAgreementLoading = false;
        if (state.onboardingQuestionnaireDetails) {
          state.onboardingQuestionnaireDetails.agreement = action.payload;
        }
      },
    )
    .addCase(
      updateOnboardingQuestionnaireAgreement.rejected,
      (state: OnboardingQuestionnaireState, action) => {
        state.error = action.error;
        state.updateAgreementLoading = false;
        toast.error(getSerializedErrorMessage(action.error));
      },
    );
}
